const NON_TEXT_CONTENT_TAGS = /<(img|table|hr|iframe|video|svg)\b/i;

/**
 * Whether the markup would show anything to a reader: text after tags, &nbsp; and zero-width characters
 * are removed, or an element that renders without text (image, table, ...).
 *
 * @param {string} markup
 * @returns {boolean}
 */
const hasVisibleMarkup = (markup) => {
    if (typeof markup !== 'string' || !markup) {
        return false;
    }
    if (NON_TEXT_CONTENT_TAGS.test(markup)) {
        return true;
    }
    const text = markup
        .replace(/<[^>]*>/g, '')
        .replace(/&nbsp;|&#160;|&#xa0;/gi, ' ')
        .replace(/[\u200B-\u200D\uFEFF\u00A0]/g, ' ');
    return text.trim().length > 0;
};

export default hasVisibleMarkup;
